@if (isMobile) {
  <div
    #mobileSheet
    appModalOverlay
    [appModalOverlayLabel]="fileName"
    (modalOverlayDismiss)="close()"
    class="file-full-preview mobile-slide-in-page tw-fixed tw-inset-0 tw-z-[100] tw-flex tw-flex-col tw-bg-color-surface-elevated"
  >
    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b tw-border-color-border-subtle tw-p-4"
    >
      <span class="tw-truncate tw-pr-3 tw-font-medium tw-text-color-text-default">{{
        fileName
      }}</span>
      <close-button type="plain" [isMatDialog]="false" (closeClickedEvent)="close()"></close-button>
    </div>
    <div class="tw-min-h-0 tw-flex-1">
      <app-file-preview
        [data]="{ file: file }"
        [hasContainer]="false"
        [mappedRows]="mappedRows"
        class="tw-h-full tw-w-full"
      ></app-file-preview>
    </div>
  </div>
} @else {
  <div
    cdkDrag
    cdkDragBoundary="body"
    class="file-full-preview tw-fixed tw-inset-0 tw-z-[100] tw-m-auto tw-flex tw-h-[70vh] tw-max-h-[92vh] tw-min-h-[320px] tw-w-[760px] tw-min-w-[360px] tw-max-w-[95vw] tw-resize tw-flex-col tw-overflow-hidden tw-rounded-xl tw-bg-color-surface-elevated tw-shadow-2xl"
  >
    <div
      cdkDragHandle
      class="tw-flex tw-cursor-move tw-items-center tw-justify-between tw-border-0 tw-border-b tw-border-color-border-subtle tw-bg-color-surface-card tw-px-4 tw-py-3"
    >
      <span class="tw-truncate tw-pr-3 tw-font-medium tw-text-color-text-default">{{
        fileName
      }}</span>
      <close-button type="plain" [isMatDialog]="false" (closeClickedEvent)="close()"></close-button>
    </div>
    <div class="tw-min-h-0 tw-flex-1">
      <app-file-preview
        [data]="{ file: file }"
        [hasContainer]="false"
        [mappedRows]="mappedRows"
        class="tw-h-full tw-w-full"
      ></app-file-preview>
    </div>
  </div>
}
